document.addEventListener("DOMContentLoaded", function () {
  if (typeof LeaderLine === "undefined") {
    return;
  }

  const emberCard = document.querySelector(".platform-section__card--ember");
  const railsCard = document.querySelector(".platform-section__card--rails");
  const postgresCard = document.querySelector(
    ".platform-section__card--postgres"
  );
  const redisCard = document.querySelector(".platform-section__card--redis");

  if (!emberCard || !railsCard || !postgresCard || !redisCard) {
    return;
  }

  // Ember to Rails
  // eslint-disable-next-line no-undef, no-new
  new LeaderLine(emberCard, railsCard, {
    startSocket: "bottom",
    endSocket: "top",
    color: "white",
    size: 3,
    startPlug: "none",
    endPlug: "behind",
  });

  // Rails to PostgreSQL
  // eslint-disable-next-line no-undef, no-new
  new LeaderLine(railsCard, postgresCard, {
    startSocket: "bottom",
    endSocket: "top",
    color: "white",
    size: 3,
    startPlug: "none",
    endPlug: "behind",
  });

  // Rails to Redis
  // eslint-disable-next-line no-undef, no-new
  new LeaderLine(railsCard, redisCard, {
    startSocket: "bottom",
    endSocket: "top",
    color: "white",
    size: 3,
    startPlug: "none",
    endPlug: "behind",
  });
});
